var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"primary"}},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_vm._v(" v"+_vm._s(_vm.$root.appVersion)+" © Copyright "+_vm._s(_vm.year)+" RealSAM Ltd. All rights reserved. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }